"use client";

import {
  IBaseTextContent,
  IRawInquiryItem,
  IServiceFormProps,
} from "@/interfaces";
import { normalizePlainText, type ServiceSeoData } from "@/lib";
import { ServiceFormCopyProvider } from "@/contexts/serviceFormCopyContext";
import ServiceSeoCacheSynchronizer from "../seo/serviceSeoCacheSynchronizer";
import ServicesPagesFormSegment from "../servicesPagesFormSegment";

const ServiceFormWrapper = ({
  serviceCost,
  serviceContext,
  component: ServiceFormComponent,
  formSegmentClassName,
  announcement,
  disableService,
  bankKey,
  serviceId,
  serviceFlag,
  relatedServices,
  seoData,
}: {
  serviceCost: number;
  serviceContext: IBaseTextContent;
  component: React.ComponentType<IServiceFormProps>;
  formSegmentClassName?: string;
  announcement?: string;
  disableService?: boolean;
  bankKey?: string;
  serviceId?: string | number;
  serviceFlag?: IRawInquiryItem["flag"];
  relatedServices?: IRawInquiryItem[];
  seoData?: ServiceSeoData;
}) => {
  const servicePrice = Number(seoData?.serviceData?.price_user ?? serviceCost);
  const canUseDynamicFormCopy = servicePrice > 0;
  const formDescription =
    canUseDynamicFormCopy && seoData?.formDescription
      ? normalizePlainText(seoData.formDescription)
      : serviceContext.description;
  const submitLabel =
    canUseDynamicFormCopy && seoData?.formSubmitLabel
      ? normalizePlainText(seoData.formSubmitLabel)
      : undefined;

  return (
    <>
      <ServiceSeoCacheSynchronizer
        serviceFlag={serviceFlag}
        seoData={seoData}
      />
      <ServicesPagesFormSegment
        {...serviceContext}
        description={formDescription}
        className={formSegmentClassName}
      >
        {({ isLoggedIn, navigateToLogin }) => (
          <ServiceFormCopyProvider value={{ submitLabel }}>
            <ServiceFormComponent
              bankKey={bankKey}
              cost={serviceCost}
              isLoggedIn={isLoggedIn}
              navigateToLogin={navigateToLogin}
              announcement={announcement}
              disableService={disableService}
              serviceId={serviceId}
              initialServiceFlag={serviceFlag}
              relatedServices={relatedServices}
              submitLabel={submitLabel}
            />
          </ServiceFormCopyProvider>
        )}
      </ServicesPagesFormSegment>
    </>
  );
};

export default ServiceFormWrapper;
